import React from 'react';
import './UserDocumentHeader.css';

const UserDocumentHeader = () => {
  return (
    <div className="user-doc-header">
      <div className="user-info">
        <span className="user-label">Herman Hoff</span>
        <span className="user-id">| 92550111078</span>
      </div>

      <select className="document-filter">
        <option>All documents</option>
        <option>Invoices</option>
        <option>Contracts</option>
        <option>Letters</option>
      </select>
    </div>
  );
};

export default UserDocumentHeader;
